import React from "react";
import PropTypes from "prop-types";
import ChartistGraph from "react-chartist";
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import MaterialTable from "material-table";
import dataoldweek from "../../dataweek.json"
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Collapse
} from "reactstrap";
import Chart from "../Chartjs/ChartData";
// import { bugs, website, server } from "variables/general.jsx";

import { completedTasksChart } from "variables/charts.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import "../Dashboard/dashboard.css";
import axios from "axios";
import ReactExport from "react-data-export";
import conf from "../../conf.json";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status1: 0,
      status11: 0,
      status12: 0,
      status13: 0,
      status14: 0,
      status2: 0,
      status3: 0,
      status4: 0,
      status5: 0,
      status0: 0,
      statusAll: 0,
      dataExcel: [],
      stat: [],
      modalExport: false,
      collapse: false,
      statChart: [],
      dateEnd: "",
      dateStart: "",
      user: [],
      selectsale: "all"
    };
    this.getStat = this.getStat.bind(this);
    this.getStatus();
    this.getSales();
    let data = JSON.parse(localStorage.getItem("data"));
    if (
      data.acstatus === "10" ||
      data.acstatus === "3" ||
      data.acstatus === "1" ||
      data.acstatus === "2"
    ) {
      this.getStat("all");
    } else {
      this.getStat(data.acusername);
    }

    this.toggleExport = this.toggleExport.bind(this);
  }

  handleSelectSale = event => {
    this.setState({
      [event.target.name]: event.target.value
    });

    this.getStat(event.target.value);
  };

  exportStatus() {
    //modalExport

    let dataExcel = [];
    this.state.stat.map(res => {
      if (this.state.dateStart !== "" && this.state.dateEnd !== "") {
        let yearStart = this.state.dateStart.split("-")[0];
        let yearEnd = this.state.dateEnd.split("-")[0];
        let weekStart = this.state.dateStart.split("-")[1].substring(1);
        let weekEnd = this.state.dateEnd.split("-")[1].substring(1);
        if (
          res.year  >= yearStart &&
          res.year  <= yearEnd &&
          res.week >= weekStart &&
          res.week <= weekEnd
        ) {
          console.log(res);
          dataExcel.push([
            {
              value: res.week,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            // {
            //   value: "test", //res.from + " - " + res.to,
            //   style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            // },
            {
              value: res.st0,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st11,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st12,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st13,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st14,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st2,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st3,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st4,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            },
            {
              value: res.st5,
              style: { font: { sz: "24", bold: true, name: "Cordia New" } }
            }
          ]);
        }
      } else {
        dataExcel.push([
          {
            value: res.week,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          // {
          //   value: res.from + " - " + res.to,
          //   style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          // },
          {
            value: res.st0,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st11,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st12,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st13,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st14,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st2,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st3,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st4,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          },
          {
            value: res.st5,
            style: { font: { sz: "24", bold: true, name: "Cordia New" } }
          }
        ]);
      }
    });
    this.setState({
      dataExcel: [
        {
          columns: [
            { title: "Week", width: { wpx: 90 } },
            // { title: "Range", width: { wch: 40 } },
            { title: "สถานะ 0", width: { wpx: 90 } },
            { title: "สถานะ 1.1", width: { wpx: 90 } },
            { title: "สถานะ 1.2", width: { wpx: 90 } },
            { title: "สถานะ 1.3", width: { wpx: 90 } },
            { title: "สถานะ 1.4", width: { wpx: 90 } },
            { title: "สถานะ 2", width: { wpx: 90 } },
            { title: "สถานะ 3", width: { wpx: 90 } },
            { title: "สถานะ 4", width: { wpx: 90 } },
            { title: "สถานะ 5", width: { wpx: 90 } }
          ],
          data: dataExcel
        }
      ]
    });
  }
  random_rgba() {
    var o = Math.round,
      r = Math.random,
      s = 255;
    //console.log('rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')')
    return (
      "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + 1 + ")"
    );
  }
  getSales() {
    let user = JSON.parse(localStorage.getItem("data"));
    axios
      .get(conf.url + "/sale", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        let sales = res.data.data.map((data, index) => {
          return (
            <MenuItem key={index} value={data.acusername}>
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });

        this.setState({
          sales: sales,
          sales_data: res.data.data
        });
      })
      .then(() => {
        this.setState({
          user: user
        });
      });
  }
  getStat(user) {
    console.log(conf.url + "/statusweek/" + user)
    axios.get(conf.url + "/statusweek/" + user).then(res => {
      if (res.status === 200) {
        // console.log(res.data.data);
        // console.log(dataoldweek)

        let tmp = [];
        let i = 0;
       // res.data.data = dataoldweek;
        // dataoldweek.map(data=>{
        //   res.data.data.push(data)
        // })
        console.log(res.data.data)
        res.data.data.map((data, index) => {
          let color = this.random_rgba();
          console.log(data.st11 +" "+ data.st12 +" "+ data.st13 +" "+ data.st14)
          console.log(data.st11 + data.st12 + data.st13 + data.st14)
          i++;
          if (i <= 2)
            tmp.push({
              label: ["Week " + data.week],
              fill: false,
              lineTension: 0.1,
              backgroundColor: color, //สีกรอบ
              borderColor: color, //สีเส้น
              borderCapStyle: "butt",
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: "miter",
              pointBorderColor: "rgba(75,192,192,1)",
              pointBackgroundColor: "#fff",
              pointBorderWidth: 1,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: "rgba(75,192,192,1)",
              pointHoverBorderColor: "rgba(220,220,220,1)",
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: [
                data.st0,
                data.st11 + data.st12 + data.st13 + data.st14,
                data.st2,
                data.st3,
                data.st4,
                data.st5
              ]
            });
        });

        this.setState({
          stat: res.data.data,
          statChart: {
            labels: [
              "สถานะ 0",
              "สถานะ 1",
              "สถานะ 2",
              "สถานะ 3",
              "สถานะ 4",
              "สถานะ 5"
            ],
            datasets: tmp
          }
        });
        //completedTasksChart.data.series = tmp;
        this.exportStatus();
      }
    });
  }
  setRowsChart(rows) {
    let tmp = [];
    //console.log(rows);
    rows.map((data, index) => {
      let color = this.random_rgba();
      tmp.push({
        label: ["Week " + data.week],
        fill: false,
        lineTension: 0.1,
        backgroundColor: color, //สีกรอบ
        borderColor: color, //สีเส้น
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [
          data.st0,
          data.st11 + data.st12 + data.st13 + data.st14,
          data.st2,
          data.st3,
          data.st4,
          data.st5
        ]
      });
    });
    this.setState({
      statChart: {
        labels: [
          "สถานะ 0",
          "สถานะ 1",
          "สถานะ 2",
          "สถานะ 3",
          "สถานะ 4",
          "สถานะ 5"
        ],
        datasets: tmp
      }
    });
  }
  getStatus() {
    let user = JSON.parse(localStorage.getItem("data"));

    let url = "";
    if (user.acstatus !== "4") {
      url = conf.url + "/status";
    } else {
      url = conf.url + "/status/" + user.acusername;
    }
    axios
      .get(url)
      .then(res => {
        if (res.status === 200) {
          let s1 = 0;
          let s11 = 0;
          let s12 = 0;
          let s13 = 0;
          let s14 = 0;
          let s2 = 0;
          let s3 = 0;
          let s4 = 0;
          let s5 = 0;
          let s0 = 0;
          let sAll = 0;
          res.data.data.map(data => {
            if (data.status === "1.1") {
              s11 += data.amount;
            } else if (data.status === "1.2") {
              s12 += data.amount;
            } else if (data.status === "1.3") {
              s13 += data.amount;
            } else if (data.status === "1.4") {
              s14 += data.amount;
            }
            if (data.status.indexOf("1.") > -1) {
              s1 += data.amount;
            } else if (data.status === "0") {
              s0 = data.amount;
            } else if (data.status === "2") {
              s2 = data.amount;
            } else if (data.status === "3") {
              s3 = data.amount;
            } else if (data.status === "4") {
              s4 = data.amount;
            } else if (data.status === "5") {
              s5 = data.amount;
            }
          });
          sAll = s1 + s2 + s3 + s4 + s5 + s0;
          this.setState({
            status1: s1,
            status2: s2,
            status3: s3,
            status4: s4,
            status5: s5,
            status0: s0,
            statusAll: sAll,
            status11: s11,
            status12: s12,
            status13: s13,
            status14: s14
          });
        }
      })
      .then(() => {
        this.setState({
          user: user
        });
      });
  }
  state = {
    value: 0
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeInput = event => {
    this.setState(
      {
        [event.target.name]: event.target.value
      },
      () => {
        this.exportStatus();
      }
    );
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  toggleExport() {
    if (this.state.modalExport === true) {
      this.setState({
        dateEnd: "",
        dateStart: ""
      });
    }
    this.setState(prevState => ({
      modalExport: !this.state.modalExport
    }));
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className="text-right">
          <Button
            color="primary"
            onClick={() => this.setState({ modalExport: true })}
          >
            <Icon style={{ paddingTop: "4px" }}>tableChart</Icon>
            <b>Export Excel</b>
          </Button>
        </div>
        {/* <GridItem xs={12} sm={6} md={3}>
            <Card className="card-cursor" onClick={this.toggleExport}>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>exit</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>ส่งออก Excel</p>
              </CardHeader>
            </Card>
          </GridItem> */}

        <GridContainer>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Icon>people</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>สถานะทั้งหมด</p>
                <h3 className={classes.cardTitle}>
                  {this.state.statusAll} <small>ราย</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>people</Icon>
                  จำนวนลูกค้าทั้งหมด
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <a href="/tables/0">
              <Card className="card-cursor">
                <CardHeader color="success" stats icon>
                  <CardIcon color="success">
                    <Icon>person_add_disabled</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>สถานะ 0</p>
                  <h3 className={classes.cardTitle}>
                    {this.state.status0} <small>ราย</small>
                  </h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Icon>person_add_disabled</Icon>
                    สถานะ 0 - ยังไม่มีการติดต่อ
                  </div>
                </CardFooter>
              </Card>
            </a>
          </GridItem>
          <GridItem
            onClick={() =>
              this.setState({
                collapse: !this.state.collapse
              })
            }
            xs={12}
            sm={6}
            md={3}
          >
            <Card className="card-cursor">
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Icon>chat_bubble</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>สถานะ 1</p>
                <h3 className={classes.cardTitle}>
                  {this.state.status1} <small>ราย</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>chat_bubble</Icon>
                  สถานะ 1 - โทรกรอง
                </div>
              </CardFooter>
              <Collapse isOpen={this.state.collapse}>
                <div style={{ margin: 30 }}>
                  <Label>
                    <a href="/tables/1">
                      <h5>สถานะ 1 - {this.state.status1} ราย</h5>
                    </a>
                  </Label>
                  <Label>
                    <a href="/tables/1/1">
                      <h5>สถานะ 1.1 - {this.state.status11} ราย</h5>
                    </a>
                  </Label>{" "}
                  <br />
                  <Label>
                    <a href="/tables/1/2">
                      <h5>สถานะ 1.2 - {this.state.status12} ราย</h5>
                    </a>
                  </Label>{" "}
                  <br />
                  <Label
                    style={{
                      display:
                        this.state.user.acstatus !== "1" ? "block" : "none"
                    }}
                  >
                    <a href="/tables/1/3">
                      <h5>สถานะ 1.3 - {this.state.status13} ราย</h5>
                    </a>
                  </Label>
                  <Label
                    style={{
                      display:
                        this.state.user.acstatus !== "1" ? "block" : "none"
                    }}
                  >
                    <a href="/tables/1/4">
                      <h5>สถานะ 1.4 - {this.state.status14} ราย</h5>
                    </a>
                  </Label>
                </div>
              </Collapse>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={3}>
            <a href="/tables/2">
              <Card className="card-cursor">
                <CardHeader color="info" stats icon>
                  <CardIcon color="info">
                    <Icon>transfer_within_a_station</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>สถานะ 2</p>
                  <h3 className={classes.cardTitle}>
                    {this.state.status2} <small>ราย</small>
                  </h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Icon>transfer_within_a_station</Icon>
                    สถานะ 2 - เข้าพบลูกค้าแล้ว
                  </div>
                </CardFooter>
              </Card>
            </a>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <a href="/tables/3">
              <Card className="card-cursor">
                <CardHeader color="primary" stats icon>
                  <CardIcon color="primary">
                    <Icon>monetization_on</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>สถานะ 3</p>
                  <h3 className={classes.cardTitle}>
                    {this.state.status3} <small>ราย</small>
                  </h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Icon>monetization_on</Icon>
                    สถานะ 3 - เสนอราคา
                  </div>
                </CardFooter>
              </Card>
            </a>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card className="card-cursor">
              <a href="/tables/4">
                <CardHeader color="rose" stats icon>
                  <CardIcon color="rose">
                    <Icon>shopping_cart</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>สถานะ 4</p>
                  <h3 className={classes.cardTitle}>
                    {this.state.status4} <small>ราย</small>
                  </h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Icon>shopping_cart</Icon>
                    สถานะ 4 - เกิดการสั่งซื้อ
                  </div>
                </CardFooter>
              </a>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card className="card-cursor">
              <a href="/tables/5">
                <CardHeader color="warning" stats icon>
                  <CardIcon color="warning">
                    <Icon>cached</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>สถานะ 5</p>
                  <h3 className={classes.cardTitle}>
                    {this.state.status5} <small>ราย</small>
                  </h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Icon>cached</Icon>
                    สถานะ 5 - ซื้อซ้ำ
                  </div>
                </CardFooter>
              </a>
            </Card>
          </GridItem>
        </GridContainer>
        <p className="text-right">
        <FormControl
          style={{ width: 200 }}
          className={classes.selectFormControl}
        >
          <InputLabel
            style={{
              display: this.state.user.acstatus !== "4" ? "block" : "none"
            }}
            htmlFor="selectsale"
            className={classes.selectLabel}
          >
            เลือกฝ่ายขาย
          </InputLabel>
          <Select
            style={{
              display: this.state.user.acstatus !== "4" ? "block" : "none"
            }}
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={this.state.selectsale}
            onChange={this.handleSelectSale}
            inputProps={{
              name: "selectsale",
              id: "selectsale"
            }}
          >
            <MenuItem key={-1} value={"all"}>
              {"ทั้งหมด"}
            </MenuItem>
            <MenuItem key={-2} value={"none"}>
              {"- ไม่มี sale -"}
            </MenuItem>
            {this.state.sales}
          </Select>
        </FormControl>
        </p>
        <GridContainer
      
        >
          <GridItem xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader
                style={{
                  height: "500px",
                  backgroundImage: "linear-gradient(to right, #B5FFFC, #FFDEE9)"
                }}
              >
                <h3 style={{ marginTop: "-5px" }}>ภาพรวมสถานะ</h3>
                {/* <ChartistGraph
                  className="ct-chart"
                  data={completedTasksChart.data}
                  type="Line"
                  options={completedTasksChart.options}
                  listener={completedTasksChart.animation}
                  style={{ height: "420px" }}
                /> */}
                <Chart
                  count={this.state.status13}
                  chartData={this.state.statChart}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>ภาพรวมจำนวนคนแต่ละสถานะ</h4>
                <p className={classes.cardCategory}>
                  กราฟแสดงจำนวนคนของสัปดาห์นั้นๆ ของแต่ละสถานะ
                </p>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer
         
        >
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>ตารางแสดงภาพรวมสถานะ</h4>
                <p className={classes.cardCategoryWhite}>
                  ตารางแสดงจำนวนคนของสัปดาห์นั้นๆ ของแต่ละสถานะ
                </p>
              </CardHeader>
              <CardBody>
                <div className="mt-4">
                  <MaterialTable
                    options={{
                      selection: true
                    }}
                    onSelectionChange={rows => this.setRowsChart(rows)}
                    columns={[
                      { title: "สัปดาห์", field: "week" },
                      {
                        title: "ปี",
                        field: "year"
                      },
                      {
                        title: "สถานะ 0",
                        field: "st0"
                      },
                      {
                        title: "สถานะ 1",
                        render: rowdata => {
                          return (
                            <div>
                              {rowdata.st11 +
                                rowdata.st12 +
                                rowdata.st13 +
                                rowdata.st14}
                            </div>
                          );
                        }
                      },
                      { title: "สถานะ 2", field: "st2" },
                      {
                        title: "สถานะ 3",
                        field: "st3"
                      },
                      {
                        title: "สถานะ 4",
                        field: "st4"
                      },
                      {
                        title: "สถานะ 5",
                        field: "st5"
                      },
                      {
                        title: "ทั้งหมด",
                        render: rowdata => {
                          return (
                            <div>
                              {rowdata.st11 +
                                rowdata.st12 +
                                rowdata.st13 +
                                rowdata.st14 +
                                rowdata.st2 +
                                rowdata.st3 +
                                rowdata.st4 +
                                rowdata.st5 +
                                rowdata.st0}
                            </div>
                          );
                        }
                      }
                    ]}
                    data={this.state.stat}
                    title="สรุปภาพรวมสถานะ"
                  />
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <Modal
          isOpen={this.state.modalExport}
          toggle={this.toggleExport}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleExport}>
            ส่งออก Export ไฟล์
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="exampleDate">เริ่ม : </Label>
                <Input
                  value={this.state.dateStart}
                  onChange={this.handleChangeInput}
                  type="week"
                  name="dateStart"
                  id="dateStart"
                  placeholder="Week"
                />
              </FormGroup>
              <FormGroup>
                <Label for="exampleDate">ถึง :</Label>
                <Input
                  onChange={this.handleChangeInput}
                  value={this.state.dateEnd}
                  type="week"
                  name="dateEnd"
                  id="dateEnd"
                  placeholder="Week"
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <ExcelFile element={<Button color="primary">Export</Button>}
            filename={'MKSP_Dashboard_'+(new Date().getDate().toString().length>1 ? new Date().getDate() : "0"+new Date().getDate().toString())   +((new Date().getMonth()+1).toString().length>1 ?( new Date().getMonth()+1) : "0"+(new Date().getMonth()+1).toString() ) +new Date().getFullYear()}
            >
              <ExcelSheet dataSet={this.state.dataExcel} name="Organization" />
            </ExcelFile>{" "}
            <Button
              color="secondary"
              onClick={() => this.setState({ modalExport: false })}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx